var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info media-type",attrs:{"id":"media"}},[_c('dropzone',{attrs:{"bucket":"img.goldfire.me","type":"editor"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }